import { Box, Checkbox, FormControlLabel, Popover, Typography } from '@mui/material'

import React, { useState } from 'react'
import { FilterIcon } from '../../assets/icons'
import { useGlobal } from '../../shared'
import { urls } from '../../shared/config'

export const FilterStudent = ({
  feeStatus,
  setFeeStatus,
  gradeValue,
  setGradeVal,
  teachers,
  setTeachers,
  vanDriver,
  setVanDriver,
  teacherFilter,
  // school_id,
  // teacher,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [anchorE2, setAnchorE2] = useState(null)
  const open = Boolean(anchorEl)
  const open2 = Boolean(anchorE2)

  const { data: gradeOptions } = useGlobal({ userUrl: urls.ALL_GRADES })
  // const { data: gradeList } = useGlobal({ userUrl: `${urls.GRADE_LIST}${school_id}` })
  // console.log('-----gradeList', gradeList)

  const [dueAmount, setDueAmount] = useState(false)
  const [grade, setGrade] = useState(false)

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  // const openDueAmount = (event) => {
  //   setAnchorE2(event.currentTarget)
  //   setDueAmount(true)
  //   setGrade(false)
  // }

  const opeGrades = (event) => {
    setAnchorE2(event.currentTarget)
    setGrade(true)
    setDueAmount(false)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const handleFeeStatus = (status) => {
    if (feeStatus == status) {
      setFeeStatus('')
    } else {
      setFeeStatus(status)
    }
  }

  const handleGradeStatus = (status) => {
    if (gradeValue == status) {
      setGradeVal('')
    } else {
      setGradeVal(status)
    }
  }

  const feeStatusOptions = [
    { label: 'UnPaid', value: 'UnPaid' },
    { label: 'Paid', value: 'Paid' },
    { label: 'Partial Paid', value: 'Partial Paid' },
  ]

  return (
    <>
      <div className="filter-box" onClick={handlePopoverOpen}>
        <img src={FilterIcon} alt="" />
        <Typography className="filter-text">Filter</Typography>
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2 }} className="change-status">
          {/* Show checkbox for teachers if true, otherwise show "Due Fees" */}
          {teacherFilter ? (
            <FormControlLabel
              control={
                <Checkbox checked={teachers} onChange={(e) => setTeachers(e.target.checked)} />
              }
              label="Primary Teacher"
            />
          ) : (
            // !teacher && (
            //   <Typography className="pop-over-text" mb={2} onClick={openDueAmount}>
            //     Due Fees
            //   </Typography>
            // )
            <></>
          )}

          {/* Show checkbox for van driver if true, otherwise show "Grade" */}
          {teacherFilter ? (
            <FormControlLabel
              control={
                <Checkbox checked={vanDriver} onChange={(e) => setVanDriver(e.target.checked)} />
              }
              label="Van Driver"
            />
          ) : (
            <Typography className="pop-over-text" onClick={opeGrades}>
              Grade
            </Typography>
          )}
        </Box>
      </Popover>
      <Popover
        open={open2 && (dueAmount || grade)}
        anchorEl={anchorE2}
        onClose={() => setAnchorE2(null)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: '10px', display: 'flex', flexDirection: 'column' }}>
          {dueAmount &&
            feeStatusOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={feeStatus === option.value}
                    onChange={() => handleFeeStatus(option.value)}
                  />
                }
                label={option.label}
              />
            ))}
          {grade &&
            gradeOptions.map((option) => (
              <FormControlLabel
                key={option.grade_id}
                control={
                  <Checkbox
                    checked={gradeValue === option.grade_id}
                    onChange={() => handleGradeStatus(option.grade_id)}
                  />
                }
                label={option.grade}
              />
            ))}
        </div>
      </Popover>
    </>
  )
}
